import type { Entity } from '@models/Entity'

import { apiClient } from '../../../gateways/api'
import type { SubprocesTemplate } from '../types/SubprocesTemplate'

export const fetchSubprocesTemplatesForEntity = async (entity: Entity) => {
  const { data } = await apiClient<SubprocesTemplate[]>({
    url: `/rest/${entity.type}/${entity.id}/subprocestemplate`,
    method: 'GET',
  })

  return data
}
